class ComponentWysiwyg {
  constructor() {
    this._init();
  }

  _init() {
    const mores = document.querySelectorAll('.more-link');

    mores.forEach((more: Element) => {
      // Init
      let parent = more.closest('p');

      let siblings = this.getNextSiblings(parent, null);
      siblings.forEach((sibling: ChildNode) => {
        (sibling as HTMLElement).classList.add('more--hide');
      });

      // Click
      (more as HTMLElement).onclick = function () {
        more.classList.add('more-link--inactive');
        siblings.forEach(function (sibling) {
          (sibling as HTMLElement).classList.remove('more--hide');
        });
      };
    });
  }

  getNextSiblings(elem: ChildNode | null, filter): ChildNode[] {
    var sibs: ChildNode[] = [];
    if (!elem) return sibs;
    while ((elem = elem.nextSibling)) {
      if (elem.nodeType === 3) continue;
      if (!filter || filter(elem)) sibs.push(elem);
    }
    return sibs;
  }
}

export const componentWysiwyg = new ComponentWysiwyg();
